import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAnalytics } from '../context/AnalyticsContext'
import { useAuth } from '../context/AuthContext'
import '../pages/onboarding/onboarding.css'

/**
 * Отдельный флоу входа: только email.
 * При успешной проверке → /login/password.
 * Назад → главная (/).
 */
const Login = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { trackEvent } = useAnalytics()
  const { user, loading, checkEmailExists } = useAuth()
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [checkingEmail, setCheckingEmail] = useState(false)

  useEffect(() => {
    if (user) {
      navigate('/app', { replace: true })
    }
  }, [user, navigate])

  const onSubmit = async (e) => {
    e.preventDefault()
    setError('')
    const value = email.trim().toLowerCase()
    if (!value) {
      setError(t('onboarding.loginEmailRequired'))
      return
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(value)) {
      setError(t('onboarding.loginEmailInvalid'))
      return
    }

    setCheckingEmail(true)
    try {
      const { exists } = await checkEmailExists(value)
      if (exists) {
        navigate('/login/password', { state: { email: value }, replace: true })
      } else {
        setError(t('onboarding.loginEmailNotFound'))
      }
    } catch (err) {
      console.error('Error checking email:', err)
      setError(t('onboarding.loginEmailError'))
    } finally {
      setCheckingEmail(false)
    }
  }

  const onBack = () => navigate('/', { replace: true })

  if (user) return null

  return (
    <div className="onboarding-page">
      <div className="onboarding-content" style={{ paddingTop: 48, paddingBottom: 120 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <button type="button" className="link" onClick={onBack} style={{ fontSize: 16 }}>
            ← {t('common.back')}
          </button>
        </div>
        <h1 className="h1">{t('onboarding.loginTitle')}</h1>
        <p className="p">{t('onboarding.loginSubtitle')}</p>
        <form onSubmit={onSubmit} style={{ marginTop: 20 }}>
          <div className="field">
            <label className="label">{t('onboarding.loginEmailLabel')}</label>
            <input
              className={`input ${error ? 'error' : ''}`}
              type="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError('') }}
              placeholder={t('onboarding.loginEmailPlaceholder')}
              inputMode="email"
              autoComplete="email"
              autoFocus
            />
          </div>
          {error ? <div className="error-text" style={{ marginTop: 8, marginBottom: 12 }}>{error}</div> : null}
        </form>
        <button
          type="button"
          className="cta-fixed"
          disabled={checkingEmail}
          onClick={onSubmit}
        >
          {checkingEmail ? t('common.checking') : t('common.continue')}
        </button>
      </div>
    </div>
  )
}

export default Login
